function ImageCell({ field, record }) {
  const _image = field.getImage(record);
  return <img src={_image} width={30} alt="image-cell" />;
}

export default ImageCell;
